import type { RequiredBy } from '../types/RequiredBy';
import { makeTypeGuardByProperty } from '../types/makeTypeGuardByProperty';
import type { OasOperationObject3XExtended } from './oas';

export type OasOperationTable = RequiredBy<
  OasOperationObject3XExtended,
  'x-table'
>;

export const isOasOperationTable = makeTypeGuardByProperty<
  OasOperationObject3XExtended,
  OasOperationTable
>('x-table');
